<template>
    <div>
        <nav-header></nav-header>
        <div class="editcompany-form validate-form p-l-50 p-r-50 p-t-10 p-b-28" >
            <section>
                <div class="page-title">
                    <h2>Editar Empresa</h2>
                </div>
                <hr/><br>
                <div class="wrap-form-fields" style="align: center">
                    <div class="input-container">
                        <label class="label-input">Nome:</label>
                        <input v-model="name" type="name" id="inputName" class="input-field" />
                    </div>
                    <br>
                    <div class="input-container">
                        <label class="label-input">CNPJ:</label>
                        <input v-model="cnpj" type="tel" v-mask="'##.###.###/####-##'" class="input-field" />
                    </div>
                    <br>
                    <div class="wrap-form-fields" style="align: center">
                        <label class="label-input">Custo por Documento:</label>
                        <b-input-group prepend="R$">
                            <b-form-input v-model="costPerReq" type="text" v-on:keyup="formatMoney('costPerReq')" class="input-field"></b-form-input>
                        </b-input-group>
                    </div>
                    <br>
                    <div class="wrap-form-fields" style="align: center">
                        <label class="label-input">Custo por Assinatura Digital:</label>
                        <b-input-group prepend="R$">
                            <b-form-input v-model="costPerSign" type="text" v-on:keyup="formatMoney('costPerSign')" class="input-field"></b-form-input>
                        </b-input-group>
                    </div>
                    <br>
                    <div class="wrap-form-fields" style="align: center">
                        <label class="label-input">Limite em megabytes mensal:</label>
                        <b-input-group append="MB">
                            <b-form-input v-model="limitMB" type="number" class="input-field"></b-form-input>
                        </b-input-group>
                    </div>
                </div>
                <button class="btn btn-secondary" v-on:click="$router.push({name:'companyManagement'})" style="aling: left; margin-left: 10px">Cancelar</button>
                <button class="btn btn-primary" v-on:click="this.updateCompany" style="aling: left">Confirmar</button>  
            </section>
        </div>
        <user-profile-footer></user-profile-footer>
    </div> 
</template>

<style scoped src="@/assets/css/util.css">
</style>

<style scoped>
    .footer {
        position: inherit !important;
    }
</style>

<script>
    import axios from 'axios';
    import config from '../helpers/generalConfig';
    import NavHeader from '../components/NavHeader.vue';
    import UserProfileFooter from '../components/UserProfileFooter.vue';
    import {mask} from 'vue-the-mask'

    export default {
        components: { NavHeader, UserProfileFooter },
        directives: { mask },
        data() {
            return {
                id: this.$route.params.companyId,
                name: '',
                cnpj: '',
                costPerReq: '',
                costPerSign: '',
                limitMB: '0',
            }
        },

        created() {
            this.findCompany()
        },

        methods: {
            findCompany() {
                axios.get(`${config.jsonServer}/company/${this.id}`, 
                    this.headers()
                )
                .then(response => {
                    this.name = response.data.nome_empresa;
                    this.cnpj = response.data.cnpj_empresa;
                    this.costPerReq = response.data.custo_requisicao.replace('$','').replace(',','').replace('.',',');
                    this.costPerSign = response.data.custo_assinatura.replace('$','').replace(',','').replace('.',',');
                    this.limitMB = response.data.limite_tamanho;
                })
                .catch((err) => {
                    if(err.response){
                        this.$root.$bvToast.toast(err.response.data.message, {
                        title: 'Erro ao buscar as informações',
                        variant: 'danger',
                        solid: true
                        });
                    }
                    this.$router.push('/home');
                });
            },

            updateCompany() {
                axios.put(`${config.jsonServer}/company/update`, {
                    id_empresa: this.id,
                    nome_empresa: this.name,
                    cnpj_empresa: this.unmask(this.cnpj),
                    custo_requisicao: this.costPerReq.replace('.', '').replace(',', '.'),
                    custo_assinatura: this.costPerSign.replace('.', '').replace(',', '.'),
                    limite_tamanho: this.limitMB || '0',
                }, this.headers())
                .then( () => {
                    this.$root.$bvToast.toast("Os dados foram atualizados!", {
                        title: 'Sucesso',
                        variant: 'success',
                        solid: true
                    });
                    this.$router.push('/companyManagement');
                })
                .catch( (err) =>{
                    if(err.response){
                        this.$bvToast.toast(err.response.data.message, {
                        title: 'Erro ao atualizar os dados',
                        variant: 'danger',
                        solid: true
                        });
                    }
                });
            },

            headers() {
                const token = this.$store.getters['auth/token'].token
                const headers = { headers: { Authorization: 'Bearer ' + token }}
                return headers;
            },

            unmask(maskedCnpj) {
                const unmaskedCnpj = maskedCnpj.replace(/[^\w\s]/gi, "");
                return unmaskedCnpj;
            },

            formatMoney(ref) {
                var value = this[ref];

                value = value + '';
                value = parseInt(value.replace(/[\D]+/g, ''));
                value = value + '';
                value = value.replace(/([0-9]{2})$/g, ",$1");

                this[ref] = value;
                if(value == 'NaN') this[ref] = '';
            }
        }        
    }
</script>